import React from 'react'
import AppDateInput from '../../../../components/AppDateInput'

export default function BiometricRecordsDateNav({
  date,
  onDateChange,
  onPrevDate,
  onNextDate,
  onToday,
  onYesterday,
}) {
  const formattedDate = new Date(date).toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-4 shadow-xs">
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-xs font-black uppercase tracking-wider text-on-surface-variant">
          Log Date:
        </span>

        {/* Date Stepper Group */}
        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={onPrevDate}
            title="Previous Day"
            className="flex h-9 w-9 items-center justify-center rounded-xl border border-outline-variant/30 bg-surface-container-low text-on-surface hover:bg-surface-container hover:text-primary transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-base">chevron_left</span>
          </button>

          <div className="w-40">
            <AppDateInput
              value={date}
              onChange={onDateChange}
              placeholder="dd-mm-yyyy"
              inputClassName="h-9 text-xs font-bold text-center"
            />
          </div>

          <button
            type="button"
            onClick={onNextDate}
            title="Next Day"
            className="flex h-9 w-9 items-center justify-center rounded-xl border border-outline-variant/30 bg-surface-container-low text-on-surface hover:bg-surface-container hover:text-primary transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-base">chevron_right</span>
          </button>
        </div>

        {/* Quick Date Presets */}
        <div className="flex items-center gap-1.5 ml-1">
          <button
            type="button"
            onClick={onYesterday}
            className="rounded-xl border border-outline-variant/20 bg-surface-container-low px-3 py-1.5 text-xs font-bold text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition cursor-pointer"
          >
            Yesterday
          </button>
          <button
            type="button"
            onClick={onToday}
            className="rounded-xl border border-primary/30 bg-primary/10 px-3 py-1.5 text-xs font-bold text-primary hover:bg-primary/20 transition cursor-pointer"
          >
            Today
          </button>
        </div>
      </div>

      {/* <div className="flex items-center gap-2 text-xs font-extrabold text-on-surface">
        <span className="material-symbols-outlined text-base text-primary">calendar_today</span>
        <span>{formattedDate}</span>
      </div> */}
    </div>
  )
}
